import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "./../context/AppContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import $ from "jquery";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";

import ic_delete from "../assets/images/ic_delete.svg";
import ic_edit from "../assets/images/ic_edit.svg";
import ic_eyes from "../assets/images/ic_eyes.svg";
import Modal from "react-bootstrap/Modal";
import {
  fetchAdminsList,
  simplePostCall,
  simpleGetCall,
  PutCallWithErrorResponse,
  DeleteCallWithErrorResponse,
  simplePostCallToken,
  DeleteCallWithErrorResponseTokan,
} from "../api/ApiServices";
import ApiConfig from "../api/ApiConfig";
import Table from "react-bootstrap/Table";
import { notifyError, notifySuccess } from "../sharedComponents/notify";
import Loading from "../sharedComponents/Loaders/Loading";
import BtnLoader from "../sharedComponents/Loaders/BtnLoader";
import { Pagination } from "./Pagination";

const Admin = () => {
  const { sidebar, rowLimit, setRowLimit, setCount, count } =
    useContext(AppContext);
  const [currentPage, setCurrentPage] = useState(0);
  const startIndex = currentPage * 15;
  const endIndex = startIndex + 15;
  const changePage = ({ selected }) => {
    setCurrentPage(selected);
  };
  const [adminList, setAdminList] = useState([]);
  const [action, setAction] = useState("add");
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  // const [singleId, setSingleId] = useState({})
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = (id) => {
    setShow(true);
  };

  // Search func()ty state
  const [searchInput, setSearchInput] = useState("");

  const handleSearchInputChange = (e) => {
    setSearchInput(e.target.value);
  };

  const [deleteModal, setDeleteModal] = useState({
    show: false,
    adminId: "",
  });
  const handleDeleteClose = () =>
    setDeleteModal({
      show: false,
      adminId: "",
    });

  const [validated, setValidated] = useState(false);

  const [addUserData, setAddUserData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile: "",
    password: "",
    confirmed_password: "",
  });

  // Bind form data
  const dataBined = (e) => {
    const re = /^[0-9\b]+$/;

    if (e.target.value === "" || re.test(e.target.value)) {
      setAddUserData({
        ...addUserData,
        [e.target.name]: e.target.value,
      });
    }
  };
  const dataInputBined = (e) => {
    let value = e.target.value;

    let valueInput = value.replace(/[^A-Za-z ]/gi, "");

    setAddUserData({
      ...addUserData,
      [e.target.name]: valueInput,
    });
  };

  useEffect(() => {
    fetchAdminList();
  }, []);

  // Fetch all Admin list function
  const fetchAdminList = () => {
    setLoading(true);
    fetchAdminsList(ApiConfig.GET_ADMIN_LIST)
      .then((res) => {
        let data = res?.data;
        if (res.result === true) {
          let filterData =
            data &&
            data.filter((item, i) => {
              return item.isDeleted === false;
            });
          setAdminList(filterData);
          setLoading(false);
        } else {
          console.log("error response,", res);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const [passwordErrMsg, setPasswordErrMsg] = useState({
    password: "",
  });

  // Add admin
  const addAdmin = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else if (addUserData.password !== addUserData.confirmed_password) {
      setPasswordErrMsg({
        ...passwordErrMsg,
        password: "Password does not match",
      });
    } else {
      setBtnLoading(true);
      let reqBody = JSON.stringify({
        first_name: addUserData.first_name,
        last_name: addUserData.last_name,
        email: addUserData.email,
        mobile: addUserData.mobile,
        password: addUserData.password,
        confirmed_password: addUserData.confirmed_password,
      });
      simplePostCallToken(ApiConfig.Add_ADMIN_DATA, reqBody)
        .then((res) => {
          console.log("add res", res);
          if (res.result === true) {
            notifySuccess(res.message);
            setBtnLoading(false);
            fetchAdminList();
            handleClose();
          } else {
            console.log("error response,", res);
            notifyError(res.message);
            setBtnLoading(false);
          }
        })
        .catch((err) => {
          // setLoading(false);
          console.log(err);
        });
    }
    setValidated(true);
  };

  // Fetch single user by id
  const getEditDataOfAdmin = (adminId) => {
    simpleGetCall(`${ApiConfig.GET_ADMIN_DATA_BY_ADMIN_ID}?id=${adminId}`)
      .then((res) => {
        console.log("Data", res);
        if (res.result === true) {
          setAddUserData({
            id: res.id,
            first_name: res.first_name,
            last_name: res.last_name,
            email: res.email,
            mobile: res.mobile,
            password: res.password,
            confirmed_password: res.confirmed_password,
          });
        }
        // setSingleId(res)
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // Update admin
  const updateAdmin = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else if (addUserData.password !== addUserData.confirmed_password) {
      setPasswordErrMsg({
        ...passwordErrMsg,
        password: "Password does not match",
      });
    } else {
      setBtnLoading(true);
      PutCallWithErrorResponse(ApiConfig.UPDATE_ADMIN_DATA, addUserData)
        .then((res) => {
          // console.log("res", res);
          if (res.json.result === true) {
            notifySuccess(res.json.message);
            setAction("add");
            fetchAdminList();
            setBtnLoading(false);
            handleClose();
          } else {
            console.log("error response", res);
            notifyError("Something went wrong");
            setBtnLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
          setBtnLoading(false);
        });
    }
    setValidated(true);
  };

  // DELETE_ADMIN_DATA
  const deleteAdmin = (adminId) => {
    DeleteCallWithErrorResponseTokan(`${ApiConfig.DELETE_ADMIN_DATA}?id=${adminId}`)
      .then((res) => {
        console.log("Data", res);
        if (res.json.result === true) {
          notifySuccess(res.json.message);
          handleDeleteClose();
          fetchAdminList();
        } else {
          console.log("error response", res);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <main
      id="cx-main"
      className={sidebar ? "admin-main" : "cx-active admin-main"}
    >
      <div className="heading-btn-main">
        <div className="heading-common">
          <label htmlFor="">ADMIN</label>
        </div>
        <div className="add-btn">
          <button
            onClick={() => {
              handleShow();
              setAddUserData({
                first_name: "",
                last_name: "",
                email: "",
                mobile: "",
                password: "",
                confirmed_password: "",
              });
              setValidated(false);
              setAction("add");
              setPasswordErrMsg({
                ...passwordErrMsg,
                password: "",
              });
            }}
          >
            Add Admin
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 24 24"
            >
              <path fill="white" d="M11 19v-6H5v-2h6V5h2v6h6v2h-6v6Z" />
            </svg>
          </button>
        </div>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {action === "edit" ? "Edit Admin" : "Add Admin"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            noValidate
            validated={validated}
            onSubmit={action === "edit" ? updateAdmin : addAdmin}
          >
            <div className="row">
              <div className="col-md-6 mb-3">
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  name="first_name"
                  value={addUserData.first_name ? addUserData.first_name : ""}
                  onChange={dataInputBined}
                  required
                  type="text"
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Your First Name.
                </Form.Control.Feedback>
              </div>
              <div className="col-md-6 mb-3">
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  name="last_name"
                  value={addUserData.last_name ? addUserData.last_name : ""}
                  onChange={dataInputBined}
                  required
                  type="text"
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Your Last Name.
                </Form.Control.Feedback>
              </div>
              <div className="col-md-6 mb-3">
                <Form.Label>Enter Email</Form.Label>
                <Form.Control
                  type="text"
                  name="email"
                  value={addUserData.email ? addUserData.email : ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    const validatedValue = value.replace(/[^a-zA-Z0-9@]/g, '');
                    setAddUserData({
                      ...addUserData,
                      email: validatedValue,
                    });
                  }}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Your Email.
                </Form.Control.Feedback>
              </div>
              <div className="col-md-6 mb-3">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  name="mobile"
                  value={addUserData.mobile ? addUserData.mobile : ""}
                  onChange={dataBined}
                  required
                  type="tel"
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Your Phone Number.
                </Form.Control.Feedback>
              </div>
              <div className="col-md-6 mb-3">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  name="password"
                  value={addUserData.password ? addUserData.password : ""}
                  onChange={(e) => {
                    setAddUserData({
                      ...addUserData,
                      password: e.target.value,
                    });
                  }}
                  required
                  type="password"
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Your Password.
                </Form.Control.Feedback>
              </div>
              <div className="col-md-6 mb-3">
                <Form.Label>Confirm Password</Form.Label>
                <Form.Control
                  name="confirmed_password"
                  value={
                    addUserData.confirmed_password
                      ? addUserData.confirmed_password
                      : ""
                  }
                  onChange={(e) => {
                    setAddUserData({
                      ...addUserData,
                      confirmed_password: e.target.value,
                    });
                  }}
                  type="password"
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Your Confirm Password.
                </Form.Control.Feedback>
                {passwordErrMsg.password && (
                  <div
                    style={{
                      marginTop: "0.25rem",
                      fontSize: ".875em",
                      color: "#dc3545",
                    }}
                  >
                    {passwordErrMsg.password}
                  </div>
                )}
              </div>
            </div>
            <div className="buttons-modal border-top pt-3 text-end ">
              <button
                className="me-2"
                type="submit"
                disabled={btnLoading ? true : false}
              >
                {btnLoading ? <BtnLoader /> : "Save"}
              </button>
              <Link to="#" className="" onClick={handleClose} type="button">
                Cancel
              </Link>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal
        show={deleteModal.show}
        onHide={handleDeleteClose}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="delete-msg text-center">
            <label htmlFor="">Do you want to delete?</label>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <div className="buttons-modal">
            <button
              className="me-2 "
              type="submit"
              style={{ backgroundColor: "red" }}
              onClick={() => {
                deleteAdmin(deleteModal.adminId);
              }}
            >
              Delete
            </button>
            <Link to="#" className="" onClick={handleDeleteClose}>
              Cancel
            </Link>
          </div>
        </Modal.Footer>
      </Modal>

      <div className="table-wrapper">
        <div className="headerFlex">
          <div className="innerLabel">
            <label className="labelTxt">
              Total Records : {adminList.length}
            </label>
          </div>
          <div className="searchFilter">
            <input
              type="text"
              className="form-control"
              placeholder="Search By Name ..."
              value={searchInput}
              onChange={handleSearchInputChange}
            />
          </div>
        </div>
        {loading ? (
          <Loading />
        ) : (
          <Table striped hover className="display">
            <thead>
              <tr>
                <th>Sr No.</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone Number</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {adminList?.length > 0 &&
                adminList
                  .filter((item) => {
                    return item.fullName
                      .toLowerCase()
                      .includes(searchInput.toLowerCase());
                  })
                  .slice(startIndex, endIndex)
                  .map((admin, index) => {
                    return (
                      <tr key={admin.id}>
                        <td>{index + 1 + startIndex}</td>
                        <td>{admin.fullName}</td>
                        <td>{admin.email}</td>
                        <td>
                          {admin.phoneNumber ? (
                            admin.phoneNumber
                          ) : (
                            <span className="text-warning">Not Updated</span>
                          )}
                        </td>
                        <td className="action">
                          <Link
                            to="#"
                            className="icon"
                            onClick={() => {
                              getEditDataOfAdmin(admin.id);
                              handleShow();
                              setValidated(false);
                              setAction("edit");
                              setPasswordErrMsg({
                                ...passwordErrMsg,
                                password: "",
                              });
                            }}
                          >
                            <img src={ic_edit} alt="" />
                          </Link>

                          <Link
                            to="#"
                            className="icon"
                            onClick={() => {
                              setDeleteModal({
                                show: true,
                                adminId: admin.id,
                              });
                            }}
                          >
                            <img src={ic_delete} alt="" />
                          </Link>
                        </td>
                      </tr>
                    );
                  })}
            </tbody>
          </Table>
        )}
        <div className="d-flex justify-content-end">
          {adminList && adminList.length > 0 ? (
            <Pagination
              changePage={changePage}
              pageCount={adminList?.length / 15}
              currentPage={currentPage}
            />
          ) : (
            <div>
              <h5 style={{ color: "red" }}> Records Not Found</h5>
            </div>
          )}
        </div>
      </div>
    </main>
  );
};

export default Admin;
